var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack217({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.2,9.36V7.92h3.74v3.42a4.74,4.74,0,0,1-1.58.93,5.91,5.91,0,0,1-2.09.4,4.65,4.65,0,0,1-2.35-.57,3.57,3.57,0,0,1-1.51-1.61,5.36,5.36,0,0,1-.5-2.29,4.91,4.91,0,0,1,.56-2.39,3.76,3.76,0,0,1,1.65-1.6,4.48,4.48,0,0,1,2.05-.42,4.08,4.08,0,0,1,2.5.67,3,3,0,0,1,1.16,1.85l-1.72.32a1.82,1.82,0,0,0-.69-1,2.08,2.08,0,0,0-1.25-.36A2.34,2.34,0,0,0,6.37,6a3,3,0,0,0-.68,2.14,3.37,3.37,0,0,0,.68,2.29,2.29,2.29,0,0,0,1.79.77A3.07,3.07,0,0,0,9.25,11a3.52,3.52,0,0,0,.94-.52V9.36Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack217);
export default __webpack_public_path__ + "static/media/Symbolpack_2_17.bbc229be8f621f95ee71057bb95d3488.svg";
export { ForwardRef as ReactComponent };